export enum MovementTypeEnum {
  ISSUE_ACCESS_CREDENTIAL = 'ISSUE_ACCESS_CREDENTIAL',
  REGISTER_LEAVE = 'REGISTER_LEAVE',
  REGISTER_ENTRY = 'REGISTER_ENTRY'
}
